var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "chart",
    staticStyle: { height: "26vh", overflow: "hidden", "text-align": "left" },
    style: { height: _vm.heightChart },
    attrs: {
      id: _vm.idGrafico,
      controllersufix: "",
      height: "26vh",
      width: "",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }